module.exports = __webpack_public_path__ + "static/media/First Light ZTG 4065_1440.91e2b760.jpeg";